import { render, staticRenderFns } from "./tab-creative.vue?vue&type=template&id=4cd71303&scoped=true"
import script from "./tab-creative.vue?vue&type=script&lang=js"
export * from "./tab-creative.vue?vue&type=script&lang=js"
import style0 from "./tab-creative.vue?vue&type=style&index=0&id=4cd71303&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd71303",
  null
  
)

export default component.exports